import { render, staticRenderFns } from "./contentUserGroupEdit.vue?vue&type=template&id=2792a018&"
import script from "./contentUserGroupEdit.vue?vue&type=script&lang=js&"
export * from "./contentUserGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports